var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "operation-class" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            [
              _c(
                "el-row",
                {
                  staticStyle: { "flex-wrap": "wrap", "align-items": "end" },
                  attrs: { type: "flex", justify: "left" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("GlobalSetObj.operationTime"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "95%" },
                            attrs: {
                              clearable: false,
                              "default-time": ["00:00:00", "23:59:59"],
                              placeholder: _vm.$t("newOrder.SelectDatetime"),
                              "range-separator": "~",
                              size: "small",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.operationTimeChange },
                            model: {
                              value: _vm.operationTimeValue,
                              callback: function ($$v) {
                                _vm.operationTimeValue = $$v
                              },
                              expression: "operationTimeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.operator") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "95%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                size: "small",
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getAllUser,
                              },
                              on: { clear: _vm.getAllUser },
                              model: {
                                value: _vm.opQuery.params.operatorId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.opQuery.params,
                                    "operatorId",
                                    $$v
                                  )
                                },
                                expression: "opQuery.params.operatorId",
                              },
                            },
                            _vm._l(_vm.allUserList, function (item, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: {
                                  label:
                                    item.realName + "（" + item.username + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.operationPage"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "95%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                size: "small",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.opQuery.params.businessType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.opQuery.params,
                                    "businessType",
                                    $$v
                                  )
                                },
                                expression: "opQuery.params.businessType",
                              },
                            },
                            _vm._l(_vm.businessTypeList, function (item, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.operatedObject"),
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "95%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseInput"
                              ),
                              clearable: "",
                              size: "small",
                            },
                            model: {
                              value: _vm.opQuery.params.businessName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.opQuery.params,
                                  "businessName",
                                  $$v
                                )
                              },
                              expression: "opQuery.params.businessName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.operationType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "95%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.opQuery.params.operationType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.opQuery.params,
                                    "operationType",
                                    $$v
                                  )
                                },
                                expression: "opQuery.params.operationType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "新增（Adicionar）",
                                  value: "ADD",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "修改（Alterar）",
                                  value: "UPDATE",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "删除（Excluir）",
                                  value: "DELETE",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "启用（Ativar）",
                                  value: "ENABLE",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "停用（Desativar）",
                                  value: "DISABLE",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "授权（Autorizar）",
                                  value: "AUTHORIZE",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "移除网点邮编（Remover CEP do Ponto）",
                                  value: "REMOVE_ZIP_CODE",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 5 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "4px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.operationSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: { click: _vm.operationReset },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("collectionCenter.reset")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              ref: "tableRef",
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: {
                size: "small",
                "max-height": "600",
                border: "",
                "header-cell-style": {
                  background: "#e1e1e1",
                  color: "#000",
                  "font-size": "15px",
                },
                data: _vm.operationTableData,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operationCenter.ind"),
                  width: "60",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.idx))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operationTime",
                  align: "center",
                  label: _vm.$t("GlobalSetObj.operationTime"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operatorName",
                  align: "center",
                  label: _vm.$t("collectionCenter.operator"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "businessType",
                  align: "center",
                  label: _vm.$t("collectionCenter.operationPage"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operationTypeDesc",
                  align: "center",
                  label: _vm.$t("collectionCenter.operationButton"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "businessName",
                  align: "center",
                  label: _vm.$t("collectionCenter.operatedObject"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "changeInfo",
                  align: "center",
                  label: _vm.$t("collectionCenter.changeInfo"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: _vm.$t("operationCenter.operate"),
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        (scope.row.oldData &&
                          Object.keys(scope.row.oldData).length > 0) ||
                        (scope.row.newData &&
                          Object.keys(scope.row.newData).length > 0)
                          ? _c(
                              "span",
                              {
                                staticClass: "detail-toggle",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("collectionCenter.detail")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.opQuery.pageNumber,
                  "page-sizes": [10, 20, 50, 100, 500, 1000],
                  "page-size": _vm.opQuery.pageSize,
                  total: _vm.operationTotal,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.opQuery, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.opQuery, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.opQuery, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.opQuery, "pageSize", $event)
                  },
                  "current-change": _vm.operationSearch1,
                  "size-change": _vm.operationSearch,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "msg_dialog_class",
          attrs: {
            title: _vm.$t("collectionCenter.operationDetails"),
            visible: _vm.detailVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.dialogList.ispms
            ? _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.dialogList.permissionList,
                        border: "",
                        "header-cell-style": {
                          background: "#f2f2f2",
                          color: "black",
                        },
                        "max-height": "600",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "pmsName",
                          label: _vm.$t("collectionCenter.pmsName"),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "msg",
                          label: _vm.$t("collectionCenter.msg"),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "op",
                          label: _vm.$t("collectionCenter.op"),
                          align: "center",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.dialogList.otherList,
                        border: "",
                        "header-cell-style": {
                          background: "#f2f2f2",
                          color: "black",
                        },
                        "max-height": "600",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "valName",
                          label: _vm.$t("collectionCenter.field"),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "oldValue",
                          label: _vm.$t("receivablePayable.BeforeOperation"),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "newValue",
                          label: _vm.$t("receivablePayable.AfterTheOperation"),
                          align: "center",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }